import React from 'react';
import Fade from 'react-reveal';
import PropTypes from 'prop-types';
import Menu from '../../components/Menu';

const Header = ({ data }) => {
  if (!data) return null;

  const { menu, name, description, platforms } = data;
  const { getAppStore, googlePlay, huaweiAppGallery, oppoStore } = platforms;

  const video = `videos/intro.mp4`;
  const getAppStoreImage = `images/stores/getapp_store.webp`;
  const googlePlayImage = `images/stores/google-play.webp`;
  const huaweiAppGalleryImage = `images/stores/huawei_app_gallery.webp`;
  const oppoStoreImage = `images/stores/oppo_store.webp`;

  return (
    <header id="home">
      <video loop autoPlay muted id="intro-video">
        <source src={video} type="video/mp4" />
      </video>

      <Menu menu={menu} />

      <div className="row banner">
        <div className="banner-text">
          <Fade bottom>
            <h1 className="responsive-headline">{name}</h1>
          </Fade>
          <Fade bottom duration={1200}>
            <h3>{description}</h3>
          </Fade>
          <hr />
          <Fade bottom duration={2000}>
            <ul className="social">
              <a
                className="mobile-btn"
                href="https://play.google.com/store/apps/details?id=worldtraveller.enoler.es.worldtraveller"
                target="_blank"
                rel="noreferrer"
              >
                <img src={googlePlayImage} alt={googlePlay} style={{ maxWidth: '250px' }} />
              </a>
            </ul>
            <ul className="social">
              <a
                className="mobile-btn"
                href="https://global.app.mi.com/details?id=worldtraveller.enoler.es.worldtraveller"
                target="_blank"
                rel="noreferrer"
              >
                <img
                  src={getAppStoreImage}
                  alt={getAppStore}
                  style={{ maxHeight: '48px', marginRight: '20px' }}
                />
              </a>
              <a
                className="mobile-btn"
                href="https://appgallery.huawei.com/app/C103155787"
                target="_blank"
                rel="noreferrer"
              >
                <img
                  src={huaweiAppGalleryImage}
                  alt={huaweiAppGallery}
                  style={{ maxHeight: '50px', marginLeft: '10px', marginRight: '10px' }}
                />
              </a>
              <a
                className="mobile-btn"
                href="https://store.oppomobile.com/"
                target="_blank"
                rel="noreferrer"
              >
                <img
                  src={oppoStoreImage}
                  alt={oppoStore}
                  style={{ maxHeight: '50px', marginLeft: '20px' }}
                />
              </a>
            </ul>
          </Fade>
        </div>
      </div>
    </header>
  );
};

Header.propTypes = {
  data: PropTypes.shape({
    name: PropTypes.string,
    description: PropTypes.string,
    platforms: PropTypes.shape({
      googlePlay: PropTypes.string,
      huaweiAppGallery: PropTypes.string,
      oppoStore: PropTypes.string,
      getAppStore: PropTypes.string,
    }),
    menu: PropTypes.shape({
      home: PropTypes.string,
      show: PropTypes.string,
      hide: PropTypes.string,
    }),
  }).isRequired,
};

export default Header;
